import axios from 'axios';

export const httpCore = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});


